import React from 'react';

import { Alert, AlertColor } from '@mui/material';

type Props = { message: string; severity?: AlertColor };

export default function ErrorDisplay({ message, severity = 'error' }: Props) {
  return <Alert severity={severity}>{message || 'There was an error'}</Alert>;
}
